import { externalToolLinkDataSelectorConfig } from './external'
import { fundScreenerSessionDataSelectorConfig } from './fundScreener'

export const selectorsConfig = {
  ...externalToolLinkDataSelectorConfig,
  ...fundScreenerSessionDataSelectorConfig,
}
